import { Injectable, Inject } from "@angular/core";
import { HttpService } from "./http.service";
import { ENV } from "../environments/environment-variables.token";
@Injectable({
  providedIn: "root",
})
export class MenuService {
  constructor(private http: HttpService, @Inject(ENV) public ENV: any) {}

  gernerateMenu() {
    this.ENV.MENU = this.validateAlias();
  }
  clearMenu() {
    this.ENV.MENU = [];
  }
  validateAlias() {
    // const session = JSON.parse(sessionStorage.getItem("permission"));
    const session = JSON.parse(localStorage.getItem("permission"));
    console.log("session", session);
    if (session !== undefined && session !== null) {
      const menus = this.menuItens();
      return menus.filter((menu) => {
        console.log("m", menu.title);
        return session.includes(menu.permission);
      });
    } else {
      return [];
    }
  }
  menuItens() {
    return [
      // {
      // 	icon: "view_carousel",
      // 	title: "Upsert Instituição",
      // 	description: "Edição e criação de instituição",
      // 	route: "/updateinstitution",
      // 	permission: "updateinstitution"
      // },
      // {
      // 	icon: "view_carousel",
      // 	title: "Home",
      // 	description: "Tela Inicial",
      // 	route: "/home",
      // 	permission: "home"
      // },
      {
        icon: "article",
        title: "Enviar Documentos",
        description:
          "Menu para envio dos documentos necessários da instituição",
        route: "/documents",
        permission: "dashboard",
      },
      // 	{
      // 		icon: "settings",
      // 		title: "Gerenciar Escala Fixa",
      // 		description: "Gerenciamento geral de escala",
      // 		route: "/dashboard",
      // 		permission: "dashboard",
      // params: {queryParams: {type: 'fixed'}}
      // 	},
      {
        icon: "settings",
        title: "Gerenciar Escala",
        description: "Gerenciamento geral de escala",
        route: "/dashboard",
        permission: "dashboard",
      },
      {
        icon: "line_style",
        title: "Escalas Diárias",
        description: "Escalas Diárias",
        route: "/daily-schedules",
        permission: "daily-schedules",
      },
      {
        icon: "dashboard",
        title: "Criação de Serviço",
        description: "Menu de Criação de Serviço",
        route: "/create-service",
        permission: "dashboard",
      },
      {
        icon: "list_alt",
        title: "Listagem de Serviços",
        description: "Todos os Serviços",
        route: "/list-service",
        permission: "list-service",
      },
      {
        icon: "store",
        title: "Listagem de Instituição",
        description: "Listagem de Instituição",
        route: "/listinstitution",
        permission: "listinstitution",
      },
      {
        icon: "list",
        title: "Listagem de Instituição Sub-Admin",
        description: "Listagem de Instituição Sub-Admin",
        route: "/list-institution-sub-admin",
        permission: "list-institution-sub-admin",
      },
      {
        icon: "supervised_user_circle",
        title: "Listagem de Usuários",
        description: "Listagem de de Usuários",
        route: "/list-users",
        permission: "list-users",
      },
      {
        icon: "view_carousel",
        title: "Solicitações de Participação",
        description: "Solicitação de Serviço",
        route: "/medical-request",
        permission: "medical-request",
      },

      {
        icon: "supervised_user_circle",
        title: "Tipos de Usuários",
        description: "Listagem de Tipos de Usuários",
        route: "/user-type-list",
        permission: "user-type-list",
      },
      {
        icon: "done_outline",
        title: "Relatório de Check-in",
        description: "Exibe dados dos checkins realizados",
        route: "/report-checkin",
        permission: "report-checkin",
      },
      {
        icon: "done_outline",
        title: "Relatório de Check-in por Hospital",
        description: "Exibe dados dos checkins realizados",
        route: "/report-checkin-hospital",
        permission: "report-checkin-hospital",
      },
      {
        icon: "alarm",
        title: "Relatório de Horas Consolidadas",
        description: "Exibe dados das horas pevistas e trabalhadas",
        route: "/report-consolided-hours",
        permission: "report-consolided-hours",
      },
      {
        icon: "alarm",
        title: "Relatório de Horas Consolidadas por Hospital",
        description: "Exibe dados das horas pevistas e trabalhadas",
        route: "/report-consolided-hours-hospital",
        permission: "report-consolided-hours-hospital",
      },
      {
        icon: "compare_arrows",
        title: "Relatório de Troca de Plantão",
        description: "Exibe dados das trocas realizadas",
        route: "/report-change-schedule",
        permission: "report-change-schedule",
      },
      {
        icon: "compare_arrows",
        title: "Relatório de Troca de Plantão por Hospital",
        description: "Exibe dados das trocas realizadas",
        route: "/report-change-schedule-hospital",
        permission: "report-change-schedule-hospital",
      },
      {
        icon: "compare_arrows",
        title: "Relatório de Solicitação de Horas Adicionais por Hospital",
        description: "Exibe solicitações realizadas por hospital",
        route: "/report-additional-hours-institution",
        permission: "report-additional-hours-institution",
      },
      {
        icon: "compare_arrows",
        title: "Relatório de Solicitação de Horas Adicionais por Serviço",
        description: "Exibe solicitações realizadas por serviço",
        route: "/report-additional-hours-service",
        permission: "report-additional-hours-service",
      },
      {
        icon: "calendar_today",
        title: "Relatório de Plantão por Hospital",
        description: "Exibe dados da escala do hospital",
        route: "/report-hospital-schedule",
        permission: "report-hospital-schedule",
      },
      {
        icon: "calendar_today",
        title: "Relatório de Logs de Escalas",
        description: "Exibe relatório de logs sobre alterações de escalas",
        route: "/report-schedule-logs",
        permission: "report-schedule-logs",
      },
      {
        icon: "calendar_today",
        title: "Relatório de Logs de Agenda",
        description:
          "Exibe relatório de logs de agenda sobre alterações de escalas",
        route: "/report-scheduleV2-logs",
        permission: "report-schedule-logs",
      },
      {
        icon: "notifications",
        title: "Notificações",
        description: "Suas notificações",
        route: "/notifications",
        permission: "notifications",
      },
      {
        icon: "graphic_eq",
        title: "Gráficos",
        description: "Seus graficos",
        route: "/graphics",
        permission: "notifications",
      },
      {
        icon: "notifications",
        title: "Solicitações",
        description: "Solicitações de tipos de usuários",
        route: "/admin-requests",
        permission: "admin-requests",
      },
      {
        icon: "notifications",
        title: "Envio de notificações",
        description: "Disparo de notificações para os usuários",
        route: "/push-notification",
        permission: "push-notification",
      },
      {
        icon: "time",
        title: "Médicos em atraso",
        description: "Disparo de notificações para os usuários em atraso",
        route: "/missing-medicals",
        permission: "missing-medicals",
      },
    ];
  }
}
